import { Map, List } from "immutable";
import { createSelector } from "utils/app.util";

const getEmployeeCardSelector = (state, employeeCardId) =>
  state
    .getIn(["cards"])
    .find(card => card.get("id").toString() === employeeCardId.toString());

export const getEmployeeCardFromState = createSelector(
  getEmployeeCardSelector,
  employeeCard => employeeCard,
);

export const getEmployeeByCardIdFromState = createSelector(
  getEmployeeCardSelector,
  employeeCard => employeeCard.get("employee"),
);

export const getEmployeeCardByEmployeeIdFromState = createSelector(
  (state, employeeId) => {
    return (
      employeeId &&
      state.getIn(["cards"]).find(card => {
        const id = card.get("employeeId");
        return id && id.toString() === employeeId.toString();
      })
    );
  },
  employeeCard => employeeCard,
);

const getWorkSchedulesSelector = (state, cardId) =>
  state.getIn(["workSchedules", "byCardId", cardId.toString()]);

export const getWorkSchedulesFromState = createSelector(
  getWorkSchedulesSelector,
  workSchedules =>
    workSchedules
      ? workSchedules
          .sortBy(workSchedule => workSchedule.get("startDate"))
          .toList()
      : undefined,
);

const getWorkScheduleSelector = (state, cardId, workScheduleId) =>
  state.getIn([
    "workSchedules",
    "byCardId",
    cardId.toString(),
    workScheduleId.toString(),
  ]);

export const getWorkScheduleFromState = createSelector(
  getWorkScheduleSelector,
  workSchedule => workSchedule,
);

const getWorkScheduleDefinitionSelector = (state, workScheduleDefinitionId) =>
  state.getIn([
    "workSchedules",
    "definitions",
    workScheduleDefinitionId.toString(),
  ]);

export const getWorkScheduleDefinitionFromState = createSelector(
  getWorkScheduleDefinitionSelector,
  workScheduleDefinition => workScheduleDefinition,
);

const getWorkScheduleDefinitionsSelector = state =>
  state.getIn(["workSchedules", "definitions"]);

export const getWorkScheduleDefinitionsFromState = createSelector(
  getWorkScheduleDefinitionsSelector,
  workScheduleDefinitions => workScheduleDefinitions.toList(),
);

const getWorkScheduleOverridesSelector = state =>
  state.getIn(["workScheduleOverrides"]);

export const getWorkScheduleOverridesFromState = createSelector(
  getWorkScheduleOverridesSelector,
  workScheduleOverrides =>
    workScheduleOverrides
      ? workScheduleOverrides.toList()
      : workScheduleOverrides,
);

const getEmployeeCoursesSelector = (state, cardId = "") =>
  state.getIn(["employeeCourses", cardId.toString()], Map());

export const getEmployeeCoursesFromState = createSelector(
  getEmployeeCoursesSelector,
  employeeCourses => employeeCourses.toList(),
);

const getEmployeeCoursesByRoleSelector = (state, cardId = "") =>
  state.getIn(["employeeCourses", cardId.toString(), "byRole"], List());

export const getEmployeeCoursesByRoleFromState = createSelector(
  getEmployeeCoursesByRoleSelector,
  employeeCourses => employeeCourses,
);

const getEmployeesProjectsCardIdFromSelector = (state, cardId = "") =>
  state.getIn(["projects", "projectsByCard", cardId.toString()]);

export const getEmployeesProjectsCardIdFromState = createSelector(
  getEmployeesProjectsCardIdFromSelector,
  projects => projects,
);
